<template>
	<Popup
		v-model="selfDisplay"
		title="客户信息"
		:confirmBtnDisplay="false"
	>
		<div v-loading="loading" style="padding: 15px;">
			
		</div>
	</Popup>
</template>

<script>
	export default {
		model: {
			prop: 'display',
			event: 'changeDisplay'
		},
		props: {
			display: Boolean
		},
		mounted () {
			this.display && (this.selfDisplay = true);
		},
		data () {
			return {
				loading: false,
				selfDisplay: false
			}
		},
		methods: {
			
		},
		watch: {
			display (newVal) {
				this.selfDisplay = newVal;
			},
			selfDisplay (newVal) {
				this.$emit("changeDisplay", newVal);
				if (newVal) {
					console.log(111);
				} else {
					this.loading = false;
				}
			}
		}
	}
</script>

<style>
</style>
